const solutionList = () => {
    const slider = document.querySelector('.solutions .solutions-list');
    const articles = document.querySelectorAll('.solutions .solutions-list .solution-with-picture');

    if (!slider) {
        return;
    }

    let isDown = false;
    let startX;
    let scrollLeft;

    slider.addEventListener('mousedown', (e) => {
        isDown = true;
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener('mouseleave', () => {
        isDown = false;
    });

    slider.addEventListener('mouseup', () => {
        isDown = false;

        setTimeout(() => {
            articles.forEach(article => {
                article.removeEventListener('click', articleLister);
            });
        }, 50);
    });

    slider.addEventListener('mousemove', (e) => {
        const x = e.pageX - slider.offsetLeft;
        const walk = (x - startX);

        if(!isDown) return;

        e.preventDefault();

        articles.forEach(article => {
            article.addEventListener('click', articleLister);
        });

        slider.scrollLeft = scrollLeft - walk;
    });

    const articleLister = (e) => {
        e.preventDefault();
    }
}

export default solutionList;
